import Vue from "vue";
// import vModal from "./components/vModal/hooks";

const requireContext = require.context("./components", true, /index\.vue$/);

requireContext.keys().forEach((filename) => {
    //  只匹配第一层文件夹, 不匹配子级
    if (filename.match(/\/components\//)) return;
    const componentConfig = requireContext(filename);
    Vue.component(
        componentConfig.default.name || componentConfig.name,
        componentConfig.default || componentConfig
    );
});

// Vue.prototype.$vModal = vModal;
